import AbstractSegment from './AbstractSegment';



const DELIMITER = '_';



export default class SchoolChoices extends AbstractSegment {
  requireYear = true;
  name = 'school_choices';



  get MAX_REGIST() { return this.config && this.config.maxRegist }



  /**
   * constructor
   */
  constructor(context) {
    super(context);
  }



  /**
   * find
   */
  find(filter = null) {
    let list = this._getList();
    if (typeof filter === 'function') {
      list = list.filter(filter);
    } else if (filter instanceof RegExp) {
      list = list.filter(code => {
        return filter.test(code);
      });
    }
    return list;
  }



  /**
   * validate cord
   */
  validate(data) {
    data = typeof data === 'string' ? [data] : data;
    const errors = [];
    data.forEach(code => {
      if (code.match(new RegExp(DELIMITER))) {
        errors.push(new Error(`${code} はフォーマットが正しくありません。`));
      }
    });
    return (errors.length ? errors : null);
  }



  /**
   * push
   */
  push(code) {
    const errors = this.validate(code);
    if (errors) return errors;
    const list = this._getList();

    if (this.MAX_REGIST && list.length >= this.MAX_REGIST) {
      return [
        new RangeError(`Has reached the upper limit. (max is ${this.MAX_REGIST})`),
      ];
    }

    list.push(code.trim());
    this.setList(list);
  }



  /**
   * 指定の値のリスト上の位置を、指定の位置へ移動する
   */
  move(code, moveTo) {
    const list  = this._getList(),
          index = list.indexOf(code);

    if (index === -1) return;

    if (moveTo === 'up') {
      moveTo = index - 1;
    } else if (moveTo === 'down') {
      moveTo = index + 1;
    }

    if (moveTo < 0 || moveTo >= list.length) return;

    // まず自分を削除
    list.splice(index, 1);

    // で目的の場所へ挿入
    list.splice(moveTo, 0, code);

    this.setList(list);
  }



  /**
   * remove by code
   */
  remove(code) {
    const list  = this._getList(),
          index = list.indexOf(code);

    if (index === -1) return;

    list.splice(index, 1);
    this.setList(list);
  }



  /**
   * remove by index
   */
  removeIndex(index) {
    const list = this._getList();
    list.splice(index, 1);
    this.setList(list);
  }



  /**
   * set list
   */
  setList(list) {
    const data = list.join(DELIMITER);
    this._set(data);
  }



  /**
   * get list
   */
  _getList() {
    const data = this._get('').trim();
    return (data === '' ? [] : data.split(DELIMITER));
  }
}



// WEBPACK FOOTER //
// ./src/shared/bc-segments/segments/SchoolChoices.js